import styled from 'styled-components';
import { Grid, TabList, TabPanel } from '@simplywallst/ui-core';

export const StyledGrid = styled(Grid)`
  height: 100%;
`;

export const StyledGridSection = styled(Grid)`
  padding: ${({ theme }) => `0 ${theme.x3spacePx}px`};
`;

export const StyledTabList = styled(TabList)`
  border: 1px solid #262e3a;
  border-radius: 4px;
`;

export const StyledGridFooter = styled(Grid)`
  border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
  margin: ${({ theme }) => `0 ${theme.x3spacePx}px`};
  padding: ${({ theme }) =>
    `${theme.x1spacePx}px 0 calc(${theme.x2spacePx}px + ${theme.safeAreaInsetBottom}) 0`};
`;

export const StyledTabPanel = styled(TabPanel)`
  margin-top: ${({ theme }) => theme.x1spacePx}px;
`;
